import React, { useState } from "react";

import thrashIcon from "assets/images/ic-thrash-red.svg";
import editIcon from "assets/images/ic-edit-black.svg";
import Icon from "components/Icon";
import {ICONS} from "constants/svgIcons";
import StorageService from "services/StorageService";
import {SESSION} from "constants/storageConstants";
import ActivationCodeService from "services/activationCode";
import toastr from "toastr";


/**
 * handleEditLimits: "Edit limit / on-off" - passed only for super admins and Admins (the server
 * refuses everyone else); absent, the action is not offered.
 */
const ActionsComponent = ({ item, handleEdit, handleDelete, handleEditLimits, withCSVDownloadButton }) => {
    const token = new StorageService().getValueByKey(SESSION)?.accessToken;
    const [isDownloadingEmails, setIsDownloadingEmails] = useState(false);

    const handleDownloadEmailsCSV = async () => {
        if (isDownloadingEmails) return;
        
        try {
            setIsDownloadingEmails(true);
            await ActivationCodeService.downloadActivationCodeEmailsCSV(item.id, item.code);
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'Failed to download emails CSV';
            toastr.error(errorMessage);
        } finally {
            setIsDownloadingEmails(false);
        }
    };

    return (
        <div className="d-flex align-items-center action-buttons">
            {item.hasAttachedEmails && (
                <span
                    className={`action-icon downloadLink cursor-pointer ${isDownloadingEmails ? 'opacity-50' : ''}`}
                    title="Download emails CSV"
                    onClick={handleDownloadEmailsCSV}
                    style={{ pointerEvents: isDownloadingEmails ? 'none' : 'auto' }}
                >
                    <Icon icon={ICONS.downloadIcon}/>
                </span>
            )}
            {withCSVDownloadButton && (
                <a
                    className="action-icon downloadLink"
                    title="Download CSV"
                    href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_API_VERSION}/clinical-admins/activation-codes/${item.id}/csv?access_token=${token}`}
                >
                    <Icon icon={ICONS.envelopeWithArrow}/>
                </a>
            )}
            {handleEdit && (
                <span className="action-icon cursor-pointer" onClick={() => handleEdit(item)} title="Edit">
                    <img src={editIcon} alt="Edit"/>
                </span>
            )}
            {handleEditLimits && (
                <button
                    type="button"
                    className="btn btn-link p-0 ml-2 font-size-13 disable-word-wrap"
                    title="Edit limit / on-off"
                    data-testid={`edit-limits-${item.id}`}
                    onClick={() => handleEditLimits(item)}
                >
                    Limit / on-off
                </button>
            )}
            {handleDelete && (
                <span className="action-icon cursor-pointer" onClick={() => handleDelete(item)} title="Delete">
                    <img src={thrashIcon} alt="Delete"/>
                </span>
            )}
        </div>
    )
}

export default ActionsComponent;
